import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Section } from './ui/Section';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { clsx } from 'clsx';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'I have bad knees / a previous injury — can I really do this?',
    answer: 'This program was specifically designed for men with joint issues. Every exercise has been vetted by sports medicine principles. The Decompress phase actually helps rehabilitate existing knee problems by fixing the mechanical imbalances that cause pain. If you have a specific surgical restriction, consult your doctor first — but most men find this program is exactly what their PT would recommend.'
  }, {
    question: 'Do I need a gym or special equipment?',
    answer: 'You can do 80% of the program with just a set of dumbbells and a resistance band. The full program works best with access to basic gym equipment (cable machine, leg press), but every exercise has a home alternative listed in the Swap Matrix.'
  }, {
    question: 'How is this different from physical therapy?',
    answer: 'Physical therapy fixes a specific injury. This program builds a complete training system that protects ALL your joints while systematically burning fat. Think of it as PT principles applied to a fat-loss program. You get the joint protection AND the body transformation.'
  }, {
    question: 'I am 60+ (or 70+). Is this too intense?',
    answer: 'No. The Armor phase uses slow-tempo movements with 50% less weight than traditional programs. We have men in their 70s following this program successfully. The intensity auto-adjusts to YOUR level because it is based on perceived effort, not fixed weights.'
  }, {
    question: 'What if it does not work for me?',
    answer: 'Then you keep the entire program and get every penny back. Our 30-day guarantee is unconditional. If your joints do not feel better and your belt is not looser, just email us. No hoops, no questions, no hard feelings. We have processed less than 3% refunds because the program works.'
  }, {
    question: 'How quickly will I see results?',
    answer: 'Most men report noticeably less joint pain within the first 7-10 days (the Decompress phase). Visible fat loss typically shows by week 2-3. By the end of the 4-week program, the average result is 10-15 lbs lost and significantly improved joint comfort.'
  }];
  return <Section background="darker" className="border-t border-slate-900" data-id="element-1">
      <div className="text-center mb-16" data-id="element-2">
        <div className="flex items-center justify-center gap-2 mb-4" data-id="element-3">
          <HelpCircle className="text-brand-orange w-6 h-6" data-id="element-4" />
          <span className="text-brand-orange font-bold uppercase tracking-widest text-sm" data-id="element-5">
            Common Questions
          </span>
        </div>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white uppercase" data-id="element-6">
          Frequently Asked <span className="text-brand-orange" data-id="element-7">Questions</span>
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-8">
        {faqs.map((faq, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.05
      }} viewport={{
        once: true
      }} className={clsx('border rounded-lg overflow-hidden transition-all duration-300', openIndex === index ? 'bg-slate-900 border-brand-orange/50 shadow-lg shadow-brand-orange/5' : 'bg-slate-900/50 border-slate-800 hover:border-slate-700')} data-id="element-9">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-10">
              <span className={clsx('font-heading font-bold text-lg uppercase pr-8', openIndex === index ? 'text-brand-orange' : 'text-white')} data-id="element-11">
                {faq.question}
              </span>
              <motion.div animate={{
            rotate: openIndex === index ? 180 : 0
          }} transition={{
            duration: 0.2
          }} data-id="element-12">
                <ChevronDown className={clsx('w-5 h-5', openIndex === index ? 'text-brand-orange' : 'text-slate-500')} data-id="element-13" />
              </motion.div>
            </button>

            <AnimatePresence data-id="element-14">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-15">
                  <div className="px-6 pb-6 text-slate-300 leading-relaxed border-t border-slate-800/50 pt-4" data-id="element-16">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </Section>;
}